<template>
    <v-col
        cols="12"
        class="mx-auto"
        style="max-width: 632px; margin-top: 131px"
    >
        <div>
            <PrimaryLoadingBar :value="currentImportedCount" :total="totalSelectedImportCount" />
            <div class="body-2 text-center mt-3">{{ fileName ? $t('Import of {0} in progress').format(fileName) : $t('Import in progress') }}</div>
            <div class="body-2 text-center mt-5 px-8">{{ $t('It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.') }}</div>
            <div class="d-flex mt-5">
                <!--<danger-button class="mx-auto" @click="onCancel">
                    {{ $t('Cancel import') }}
                </danger-button>-->
            </div>
        </div>
    </v-col>
</template>

<script>
import { Router } from "@/composables/Router";
import { formatDateTime } from "@/plugins/formatting";
import {onMounted, onUnmounted, reactive, ref} from "@vue/composition-api";
import { $t } from "@/i18n";
import Dialog from "@/components/Dialog.vue";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import RichDataTable from "@/components/RichDataTable/RichDataTable";
import ImportResultModule from "@/views/Import/Result/ImportResultModule";
import ImportResultRowClientStatus from "@/views/Import/Result/ImportResultRowClientStatus";
import PrimaryLoadingBar from "@/components/LoadingBar/PrimaryLoadingBar";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import ApiIntegrationImport from "@/api/integration/import";
import WS from "@/utility/webSocket";
import DialogModule from "@/store/modules/dialog"
import AppModule from "@/store/modules/app";
import {capitalize} from "@/plugins/formatting";

export default {
    name: "ImportResultView",
    components: {
        PrimaryLoadingBar,
        RichDataTable,
        Dialog,
        ImportResultRowClientStatus
    },
    setup() {
        const { setPageTitle } = AppModule();
        const router = Router();
        const importSessionId = ref(parseInt(router.currentRoute.params.id));
        const importSession = ref(null);
        const currentImportedCount = ref(5);
        const totalSelectedImportCount = ref(100);
        const fileName = ref('');
        const dialogModule = DialogModule()

        const onWsMessage = (msg) => {
            if (msg && msg.import_session_id === importSessionId.value && msg.imported_count) {
                currentImportedCount.value = msg.imported_count
                totalSelectedImportCount.value = msg.import_total_count
            }
        }

        const webSocket = reactive(new WS(onWsMessage, "/ws/import"))

        onMounted(async () => {
            webSocket.connect(async () => {
                try {
                    const response = await ApiIntegrationImport.getImportSession(importSessionId.value)

                    importSession.value = response.import_session

                    const pageTitleFileName = response.import_session.file_type === 'xlsx' ? 'Excel' : response.import_session.file_type
                    const pageTitle = $t('Import clients from {0}').format(capitalize(pageTitleFileName))
                    setPageTitle(pageTitle)

                    if (response.import_session.status !== 'importing') {
                        currentImportedCount.value = 100
                    }

                    if (response.import_session.file) {
                        fileName.value = response.import_session.file.file_name
                    }
                } catch (e) {
                    errorDialog.showError(e)
                }
            }, () => errorDialog.showError($t("Failed to connect to server")))
        })

        onUnmounted(async () => {
            webSocket.close()
        })

        const onCancel = async () => {
            dialogModule.setConfirmOptions({
                title: $t("Are you sure you want to cancel import?"),
                confirm_text: $t("Delete"),
                cancel_text: $t("Cancel"),
                action: async () => {
                    try {
                        await ApiIntegrationImport.cancelImport(importSessionId.value)
                        router.push({ name: 'import_selection', params: { account_id: importSession.value.account_id }})
                    } catch (e) {
                        errorDialog.showError(e)
                    }
                }
            });
            dialogModule.openConfirmDialog();
        }

        return {
            formatDateTime,
            ImportResultModule,
            importSession,
            currentImportedCount,
            totalSelectedImportCount,
            onCancel,
            fileName
        };
    }
};
</script>
